// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l0FKkBDwWhOMuiaIaF8m {
  min-width: 215px;
  width: 215px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-x: visible;
  position: relative;
}

.oWkADH2Qxa9A3QIqC5Im {
  display: flex;
  align-items: center;
  height: 58px;
  width: 40px;
}

.GyhuJ5yjiA1bXHoYG0Ew {
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  overflow-x: visible;
  position: relative;
}

.fHurwOc_pnDWYCZAhJi6 {
  height: 58px;
}

.IhMeyaJ5CKi2VHwj_nOY {
  background-color: var(--grey-color-400);
  width: 100%;
  overflow-x: visible;
  position: relative;
}

.TX_DW4aeSlG5qIgUX5XQ {
  display: flex;
  align-items: center;
  height: 58px;
  height: 58px;
  width: 100%;
  padding: 0 0 0 16px;
  overflow-x: visible;
  position: relative;
}

.Mu0WAdw9QMwSXkoI1h4n {
  display: flex;
  align-items: center;
  height: 58px;
  height: 58px;
  padding: 0 0 0 16px;
  background-color: var(--background-color);
  border-bottom: 1px solid var(--grey-color-400);
  border-top: 1px solid var(--grey-color-400);
  border-left: 1px solid var(--grey-color-400);
  border-radius: 14px 0 0 14px;
  overflow-x: visible;
  position: relative;
}

.tqbXk6UhcyM3LKEl672u {
  display: flex;
  align-items: center;
  height: 58px;
  width: 100%;
}

.TVCV6MMYdSDtaCvsapFt {
  display: flex;
  align-items: center;
  height: 58px;
  position: relative;
  padding: 0 16px;
  overflow-x: visible;
  width: 100%;
}

.NJTtGB8htne2Ao2qXNnC {
  border: 1px solid var(--grey-color-400);
  border-radius: 14px;
  position: relative;
  overflow-y: hidden;
  overflow-x: visible;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  width: 100%;
  cursor: pointer;
}

.D_tVPMxNzdwfM0Nwv2RX {
  overflow-x: visible;
  position: relative;
}

.e1OjMeTqmQYJqnJ_rpbk {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.cl7J15Z2gdPWc2r8h4k6 {
  overflow-x: visible;
  position: relative;
}

.l9FYPHby1ZkRj1LYML_l {
  left: 197px;
  height: 58px;
  width: 29px;
  background-color: var(--background-color);
  border-bottom: 1px solid var(--grey-color-400);
  border-top: 1px solid var(--grey-color-400);
  position: absolute;
  z-index: 5;
}

.erCr16g6LM9Y_jQ2z5in {
  left: 226px;
  height: 2px;
  width: 12px;
  border-left: 1px solid var(--grey-color-400);
  border-bottom: 1px solid var(--grey-color-400);
  background-color: var(--background-color);
  position: absolute;
  z-index: 5;
}

.vL0Xs1G45ndohi2Mj1bG {
  left: 226px;
  height: 12px;
  width: 12px;
  background-color: var(--background-color);
  position: absolute;
  z-index: 5;
}

.aLqOK6morqQiECfXQmh5 {
  width: 100%;
  border: 1px solid var(--grey-color-400);
  border-radius: 14px;
  padding: 16px;
}

.Dlk5rOLyIVEak5r0ZE0E {
  position: relative;
  overflow-x: visible;
  display: flex;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/PaneSelector/PaneSelector.module.scss"],"names":[],"mappings":"AAWA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AAVF;;AAaA;EAfE,aAAA;EACA,mBAAA;EACA,YAAA;EAeA,WAAA;AARF;;AAWA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,uCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AARF;;AAWA;EAxCE,aAAA;EACA,mBAAA;EACA,YAAA;EAwCA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;AANF;;AASA;EAjDE,aAAA;EACA,mBAAA;EACA,YAAA;EAiDA,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,8CAAA;EACA,2CAAA;EACA,4CAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAOA;EA9DE,aAAA;EACA,mBAAA;EACA,YAAA;EA8DA,WAAA;AAFF;;AAKA;EAnEE,aAAA;EACA,mBAAA;EACA,YAAA;EAmEA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAAF;;AAGA;EAhFE,uCAAA;EACA,mBAAA;EAiFA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yCAAA;EACA,8CAAA;EACA,2CAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,4CAAA;EACA,8CAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,WAAA;EA5IA,uCAAA;EACA,mBAAA;EA6IA,aAAA;AAEF;;AACA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAEF","sourcesContent":["@mixin border {\n  border: 1px solid var(--grey-color-400);\n  border-radius: 14px;\n}\n\n@mixin centerable {\n  display: flex;\n  align-items: center;\n  height: 58px;\n}\n\n.selectors {\n  min-width: 215px;\n  width: 215px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-x: visible;\n  position: relative;\n}\n\n.carrot {\n  @include centerable;\n  width: 40px;\n}\n\n.innerSelector {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  cursor: pointer;\n  overflow-x: visible;\n  position: relative;\n}\n\n.collapsed {\n  height: 58px;\n}\n\n.selected {\n  background-color: var(--grey-color-400);\n  width: 100%;\n  overflow-x: visible;\n  position: relative;\n}\n\n.nestedCell {\n  @include centerable;\n  height: 58px;\n  width: 100%;\n  padding: 0 0 0 16px;\n  overflow-x: visible;\n  position: relative;\n}\n\n.nestedSelectionCell {\n  @include centerable;\n  height: 58px;\n  padding: 0 0 0 16px;\n  background-color: var(--background-color);\n  border-bottom: 1px solid var(--grey-color-400);\n  border-top: 1px solid var(--grey-color-400);\n  border-left: 1px solid var(--grey-color-400);\n  border-radius: 14px 0 0 14px;\n  overflow-x: visible;\n  position: relative;\n}\n\n.rootLabel {\n  @include centerable;\n  width: 100%;\n}\n\n.cell {\n  @include centerable;\n  position: relative;\n  padding: 0 16px;\n  overflow-x: visible;\n  width: 100%;\n}\n\n.selector {\n  @include border;\n  position: relative;\n  overflow-y: hidden;\n  overflow-x: visible;\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px;\n  width: 100%;\n  cursor: pointer;\n}\n\n.nestedLabel {\n  overflow-x: visible;\n  position: relative;\n}\n\n.nestedLabelSpacer {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.nestedSet {\n  overflow-x: visible;\n  position: relative;\n}\n\n.whiteSpace {\n  left: 197px;\n  height: 58px;\n  width: 29px;\n  background-color: var(--background-color);\n  border-bottom: 1px solid var(--grey-color-400);\n  border-top: 1px solid var(--grey-color-400);\n  position: absolute;\n  z-index: 5;\n}\n\n.bottomBorder {\n  left: 226px;\n  height: 2px;\n  width: 12px;\n  border-left: 1px solid var(--grey-color-400);\n  border-bottom: 1px solid var(--grey-color-400);\n  background-color: var(--background-color);\n  position: absolute;\n  z-index: 5;\n}\n\n.bottomWhitespace {\n  left: 226px;\n  height: 12px;\n  width: 12px;\n  background-color: var(--background-color);\n  position: absolute;\n  z-index: 5;\n}\n\n.pane {\n  width: 100%;\n  @include border;\n  padding: 16px;\n}\n\n.paneSelector {\n  position: relative;\n  overflow-x: visible;\n  display: flex;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectors": `l0FKkBDwWhOMuiaIaF8m`,
	"carrot": `oWkADH2Qxa9A3QIqC5Im`,
	"innerSelector": `GyhuJ5yjiA1bXHoYG0Ew`,
	"collapsed": `fHurwOc_pnDWYCZAhJi6`,
	"selected": `IhMeyaJ5CKi2VHwj_nOY`,
	"nestedCell": `TX_DW4aeSlG5qIgUX5XQ`,
	"nestedSelectionCell": `Mu0WAdw9QMwSXkoI1h4n`,
	"rootLabel": `tqbXk6UhcyM3LKEl672u`,
	"cell": `TVCV6MMYdSDtaCvsapFt`,
	"selector": `NJTtGB8htne2Ao2qXNnC`,
	"nestedLabel": `D_tVPMxNzdwfM0Nwv2RX`,
	"nestedLabelSpacer": `e1OjMeTqmQYJqnJ_rpbk`,
	"nestedSet": `cl7J15Z2gdPWc2r8h4k6`,
	"whiteSpace": `l9FYPHby1ZkRj1LYML_l`,
	"bottomBorder": `erCr16g6LM9Y_jQ2z5in`,
	"bottomWhitespace": `vL0Xs1G45ndohi2Mj1bG`,
	"pane": `aLqOK6morqQiECfXQmh5`,
	"paneSelector": `Dlk5rOLyIVEak5r0ZE0E`
};
export default ___CSS_LOADER_EXPORT___;
